import api from "./api";

// Shared per-path SEO meta fetch (memoised) so SeoHead and the visible
// Breadcrumbs read from the SAME response — guaranteeing the on-page
// breadcrumb trail matches the BreadcrumbList JSON-LD exactly.
const cache = new Map();

export function fetchSeoMeta(path) {
  if (cache.has(path)) return cache.get(path);
  const p = api
    .get(`/seo/meta?path=${encodeURIComponent(path)}`)
    .then((r) => r.data)
    .catch(() => null);
  cache.set(path, p);
  return p;
}
